// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"bbf5fd7a","151":"126bf43c","279":"9806c1f8","380":"677ffa75","543":"0e3d0ddb","596":"e1921d0a","765":"f9ccf38b"}[chunkId] + ".chunk.js";
};